import React, { Component } from "react";
import { IntlProvider } from "react-intl";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import DynamicForm from "Component/DynamicForm";
import { multiselectinputconverter } from "Component/DynamicForm/Fields/MultiSelect";
import { radioinputconverter } from "Component/DynamicForm/Fields/Radio";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { textareainputconverter } from "Component/DynamicForm/Fields/Textarea";
import { ErrorMessages } from "Constants";
import { instance } from "Actions/AxiosInstance";
import Select from "react-select";
import Requistions from "./Requistions";

export default class Create extends Component {
  constructor(props) {
    super(props);
    // this.state = {
    //   owneremployeeid: null,
    //   employee: [],
    //   activeStep: 0,
    //   AllStep: [],
    //   completed: false,
    //   postData: props.postData,
    //   allemployees: [],
    // };
    this.state = {
      owneremployeeid: null,
      employee: [],
      activeStep: 0,
      AllStep: [],
      completed: false,
      postData: props.postData,
      allemployees: [],
      hiringmanager:
        (this.props.postData.hiringmanager &&
          this.props.postData.hiringmanager.map((x) => {
            x.displayname = x.fullname;
            x.displayvalue = x.employeeid;
            return x;
          })) ||
        [],
      temphiringmanager:
        (this.props.postData.hiringmanager &&
          this.props.postData.hiringmanager.map((x) => {
            x.displayname = x.fullname;
            x.displayvalue = x.employeeid;
            return x;
          })) ||
        [],
      tempowner:
        (this.props.postData.owner &&
          this.props.postData.owner.map((x) => {
            x.displayname = x.fullname;
            x.displayvalue = x.employeeid;
            return x;
          })) ||
        [],
      owner:
        (this.props.postData.owner &&
          this.props.postData.owner.map((x) => {
            x.displayname = x.fullname;
            x.displayvalue = x.employeeid;
            return x;
          })) ||
        [],
    };
    // this.setStep = this.setStep.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.updatePostData = this.updatePostData.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.getAllEmp = this.getAllEmp.bind(this);
  }

  componentDidMount() {
    this.getAllEmp();
  }

  getAllEmp() {
    const { login } = this.props.AuthenticationAction;
    const data = {
      featurekey: "reviewform",
      subscriptionid: login.subscriptionid,
    };
    instance
      .post(`subscription/getemployeelist`, data)
      .then((result) => {
        this.setState({
          allemployees: result.data.result,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  updatePostData(key, value) {
    const temparray = [];
    const temparray1 = [];
    const { postData, employee } = this.state;

    if (key == "owneremployeeid") {
      // value &&
      //   value.forEach((element) => {
      const item = {};
      item.employeeid = value.displayvalue;
      item.hiringplanpartnerid = value.hiringplanpartnerid || null;
      item.partnertypeid = 1;
      temparray.push(item);
      //   });
      postData.owner = temparray;
      postData[key] = value;
      this.setState({ postData, owner: value });
    } else if (key == "employeeid") {
      value &&
        value.forEach((element) => {
          const item1 = {};
          item1.employeeid = element.displayvalue;
          item1.hiringplanpartnerid = element.hiringplanpartnerid || null;
          item1.partnertypeid = 2;
          temparray1.push(item1);
        });
      postData.hiringmanager = temparray1;
      this.setState({ postData, hiringmanager: value });
    } else {
      postData[key] = value;
      this.setState({ postData });
    }
  }

  onNextClick = (selectedReview) => {
    this.setState(
      {
        selectedReview,
      },
      () => {
        if (this.child) {
          this.child.handleNext();
        }
      },
    );
  };

  onCancel = () => {
    this.props.enqueueSnackbar(` Are you sure, you would lost your progress?`, {
      variant: "warning",
      action: [
        <Button
          key="key"
          color="inherit"
          size="small"
          // onClick={() => {
          //   // this.props.history.push(`app/recruit/hiring_plan`);
          //   this.props.history.push(`${this.props.match.url}/hiring_plan`);
          //   this.props.closeSnackbar();
          // }}
          onClick={() =>
            this.setState(
              {
                backupList: [],
                fullcount: 1,
                listdata: [],
                offset: 0,
                createmenu: false,
              },
              () => {
                this.props.getAllHiringPlan(false);
                this.props.closeSnackbar();
                this.props.history.push(`${this.props.match.url}/hiring_plan`);
              },
            )
          }
        >
          Yes
        </Button>,
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          No
        </Button>,
      ],
    });
  };

  onPrevClick = () => {
    this.child.handleBack();
  };
  // onSave() {
  //   if (!this.state.questioncategoryid
  //   ) {
  //     this.props.enqueueSnackbar("Please select Question category", { variant: "error" });
  //   } else if (this.state.questiontext == null) {
  //     this.props.enqueueSnackbar("Please Enter a question", { variant: "error" });
  //   } else if (this.state.inputvaluetypeid == 0) {
  //     this.props.enqueueSnackbar("Please select answer type", { variant: "error" });
  //   } else {
  //     const data = {
  //       questionid: this.state.questionid,
  //       questioncategoryid: this.state.questioncategoryid,
  //       questiontext: this.state.questiontext,
  //       inputvaluetypeid: this.state.inputvaluetypeid,
  //       questioninputoption: this.state.questioninputoption,
  //     };
  //     instance.post('recruit/configquestion', data).then(() => {
  //       this.props.enqueueSnackbar(ErrorMessages.E0000, {
  //         variant: "success",
  //       });
  //       this.props.history.push(`${this.props.match.path}/list`);
  //       this.props.getAllQuestion();
  //     }).catch((error) => {
  //       const CommonError = error.response ? error.response.data.error.message : error.message;
  //       this.props.enqueueSnackbar(CommonError, { variant: "error" });
  //     });
  //   }
  // }

  onSave() {
    const { postData } = this.state;

    let isremovedmanager = false;
    this.state.temphiringmanager.map((x) => {
      const data = postData.hiringmanager.find(
        (y) => y.hiringplanpartnerid == x.hiringplanpartnerid,
      );
      if (!data) {
        isremovedmanager = true;
      }
    });
    let isremoveowner = false;
    this.state.tempowner.map((x) => {
      const data = postData.owner.find(
        (y) => y.hiringplanpartnerid == x.hiringplanpartnerid,
      );
      if (!data) {
        isremoveowner = true;
      }
    });
    const removedmanager = isremovedmanager
      ? this.state.temphiringmanager.filter(
          (device) =>
            device.hiringplanpartnerid !=
            postData.hiringmanager.map(
              (olddevice) => olddevice.hiringplanpartnerid,
            ),
        )
      : [];

    const removeowner = isremoveowner
      ? this.state.tempowner.filter(
          (device) =>
            device.hiringplanpartnerid !=
            postData.owner.map((olddevice) => olddevice.hiringplanpartnerid),
        )
      : [];

    const removeddata =
      removedmanager.concat(removeowner) &&
      removedmanager.concat(removeowner).map((x) => {
        const data = {};
        data.hiringplanid = postData.hiringplanid;
        data.hiringplanpartnerid = x.hiringplanpartnerid;
        return data;
      });

    const objData = {
      hiringplanid: postData.hiringplanid,
      name: postData.name,
      description: postData.description,
      isactive: true,

      isapprovalrequired: postData.isapprovalrequired,
      // owner: [],
      deletehiringplanpartner: removeddata ? removeddata : [],
      hiringplanpartner:
        postData.hiringmanager && postData.hiringmanager.concat(postData.owner),
    };
    if (!postData.name) {
      this.props.enqueueSnackbar("Please fill hiring plan name", {
        variant: "error",
      });
    } else if (
      !postData.hiringmanager ||
      (postData.hiringmanager && postData.hiringmanager.length == 0)
    ) {
      this.props.enqueueSnackbar("Please select hiring manager", {
        variant: "error",
      });
    } else {
      this.setState({
        isDisableSaveButton: true,
      });
      instance
        .post("recruit/confighiringpplan", objData)
        .then(() => {
          this.props.enqueueSnackbar(ErrorMessages.E0000, {
            variant: "success",
          });
          this.props.getAllHiringPlan(true);

          this.setState({
            postData: [],
            isDisableSaveButton: false
          });
          // this.props.history.push(`${this.props.match.path}`);

          this.props.history.push(`${this.props.match.url}/hiring_plan`);
        })
        .catch((error) => {
          this.props.enqueueSnackbar(error.message, {
            variant: "error",
          });
          this.setState({
            isDisableSaveButton: false
          });
        });
    }
  }

  render() {
    const { postData, owneremployeeid, isDisableSaveButton } = this.state;
    return (
      <div
        className="content-outer-wrapper-with-tab"
        style={{ paddingBottom: 80 }}
      >
        <Grid container>
          <Grid item xs={12} md={12} sm={12}>
            <div style={{ width: 300 }}>
              <DynamicForm
                fields={textinputconverter({
                  value: postData.name,
                  placeholder: "Enter name",
                  label: "Let’s give this hiring plan a name!",
                })}
                onChange={(value) => {
                  this.updatePostData("name", value);
                }}
              />
              <DynamicForm
                fields={textareainputconverter({
                  value: postData.description,
                  placeholder: "Enter description",
                  label: "Description",
                })}
                onChange={(value) => {
                  this.updatePostData("description", value);
                }}
              />
              <div style={{ marginBottom: 16 }}>
                <p className="input-label">Assign plan owner</p>
                <Select
                  value={this.state.owner}
                  onChange={(ids) => {
                    this.updatePostData("owneremployeeid", ids);
                  }}
                  options={this.state.allemployees}
                  getOptionLabel={(option) => option.displayname}
                  getOptionValue={(option) => option.displayvalue}
                  isClearable={true}
                />
              </div>
              {/* <DynamicForm
                    fields={multiselectinputconverter({
                      value: owneremployeeid,
                      label: "Assign plan owner(s)",
                      placeholder: "",
                      options: this.state.allemployees,
                    })}
                    onChange={(ids) => {
                      this.updatePostData("owneremployeeid", ids);
                    }}
                  />
                  {this.state.employee.length > 0 ? (
                    <paper>
                      {this.state.employee.map((item) => item.employeeid[0].displayname)}
                    </paper>
                  ) : ""} */}
              <div style={{ marginBottom: 16 }}>
                <p className="input-label">Assign hiring manager(s)</p>
                <Select
                  value={this.state.hiringmanager}
                  isMulti
                  onChange={(ids) => {
                    this.updatePostData("employeeid", ids);
                  }}
                  options={this.state.allemployees}
                  getOptionLabel={(option) => option.displayname}
                  getOptionValue={(option) => option.displayvalue}
                  isClearable={true}
                />
              </div>

              <p className="input-label margin-bottom-8">
                Require approval for adding requisition?
              </p>
              <span className="floatleft width50">
                <DynamicForm
                  className="width100"
                  fields={radioinputconverter({
                    value: postData.isapprovalrequired == true,
                    label: "Yes",
                  })}
                  onChange={() =>
                    this.updatePostData("isapprovalrequired", true)
                  }
                />
              </span>
              <span className="floatleft width50">
                <DynamicForm
                  className="width100"
                  fields={radioinputconverter({
                    value: postData.isapprovalrequired == false,
                    label: "No",
                  })}
                  onChange={() =>
                    this.updatePostData("isapprovalrequired", false)
                  }
                />
              </span>
            </div>
          </Grid>
        </Grid>
        <div
          className="width100"
          style={{
            position: "fixed",
            left: 0,
            background: "white",
            bottom: 0,
            padding: 10,
            borderTop: "1px solid #d4d4d4",
            zIndex: 0,
          }}
        >
          <div>
            <div className="floatleft" style={{ marginLeft: 304 }}>
              <Button
                className="btn btn-secondary-md-blue margin-right-16"
                variant="contained"
                onClick={this.onCancel}
              >
                Cancel
              </Button>
            </div>
            <div className="floatright" style={{ marginRight: 72 }}>
              <div>
                <Button
                  className="btn btn-primary-md-blue margin-right-16"
                  variant="contained"
                  onClick={() => this.onSave()}
                  disabled={isDisableSaveButton}
                >
                  Save
                </Button>
              </div>
            </div>
            <div className="clearfloat"></div>
          </div>
        </div>
      </div>
    );
  }
}
